import { render, staticRenderFns } from "./form-custom.vue?vue&type=template&id=4b9a7758&"
import script from "./form-custom.vue?vue&type=script&lang=ts&"
export * from "./form-custom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports